enum DocumentCategory {
    SITE_INSPECTION = "site_inspection",
    HISTORICAL_DATA = "historical_data",
    SURVEY_DATA = "survey_data"
  }
  
  export default DocumentCategory;
  